import Tracker from "@openreplay/tracker";
import trackerAssist from "@openreplay/tracker-assist";
import { readConfigValue } from "config/config";

type OpenReplayConfig = {
  openReplayProjectKey: string | undefined;
  openReplayIngestPoint: string | undefined;
};

type OpenReplaySettings = {
  projectKey: string;
  ingestPoint: string;
};

type OpenReplayUserMetadata = {
  email: string;
};

let openReplayTracker: Tracker | null = null;
let openReplayStarted = false;
let openReplayMetadata: OpenReplayUserMetadata | null = null;

function readOpenReplaySettings(
  config: OpenReplayConfig
): OpenReplaySettings | null {
  const projectKey = readConfigValue(config.openReplayProjectKey);
  const ingestPoint = readConfigValue(config.openReplayIngestPoint);

  if (projectKey === undefined || ingestPoint === undefined) {
    return null;
  }

  return { projectKey, ingestPoint };
}

function applyOpenReplayMetadata(): void {
  if (openReplayMetadata !== null) {
    openReplayTracker?.setMetadata("email", openReplayMetadata.email);
  }
}

export function initOpenReplay(config: OpenReplayConfig, userId: string): void {
  if (openReplayTracker !== null) {
    return;
  }

  const settings = readOpenReplaySettings(config);
  if (settings === null) {
    return;
  }

  try {
    openReplayTracker = new Tracker({
      projectKey: settings.projectKey,
      ingestPoint: settings.ingestPoint,
      canvas: { disableCanvas: true },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return;
  }

  try {
    openReplayTracker.use(trackerAssist());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  openReplayTracker
    .start({ userID: userId, forceNew: true })
    .then((session) => {
      if (!session.success) {
        // eslint-disable-next-line no-console
        console.error(session.reason);
        return;
      }

      openReplayStarted = true;
      applyOpenReplayMetadata();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

export function setOpenReplayMetadata({ email }: OpenReplayUserMetadata): void {
  openReplayMetadata = { email };

  if (openReplayStarted) {
    applyOpenReplayMetadata();
  }
}
